
import { ChatServices } from '@/services/chat.service'

const state = {
  loading: false,
  dialog: false,
  overlay: false,
  chatlist: [],
  totalchatlist: 0,
  messages: [],
  selectedgroupid: 0,
  selectedchat: null,
  newmessage: {
    touser: {
      memberid: 0,
      membername: '',
      avatar: ''
    },
    msg: '',
    groupid: 0
  }
}
const actions = {
  setloading ({ commit }, data) {
    commit('setloading', data)
  },
  setdialog ({ commit }, diag) {
    commit('setdialog', diag)
  },
  setToUser ({ commit }, touser) {
    commit('settouser', touser)
  },
  setselectedgroupid ({ commit }, groupid) {
    commit('setselectedgroupid', groupid)
  },
  setselectedchat ({ commit }, chat) {
    commit('setselectedchatx', chat)
  },
  getChatList ({ commit }) {
    commit('setloading', true)
    ChatServices.getChatList().then(value => {
      commit('setloading', false)
      commit('setchatlist', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  getMessages ({ commit }, groupid) {
    commit('setloading', true)
    ChatServices.getMessage(groupid).then(value => {
      commit('setloading', false)
      commit('setdatamessage', value)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  addMessage ({ commit }, data) {
    commit('setloading', true)
    ChatServices.addMessage(data).then(value => {
      commit('setloading', false)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  sendMessage ({ dispatch, commit }, data) {
    commit('setloading', true)
    ChatServices.addMessage(data).then(value => {
      commit('setloading', false)
      dispatch('getMessages', data.groupid)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  },
  doReadGroupMSg ({ dispatch, commit }, groupid) {
    commit('setloading', true)
    ChatServices.readgroupmsg(groupid).then(value => {
      commit('setloading', false)
    }).catch(reason => {
      console.log(reason)
      commit('setloading', false)
    })
  }
}
const mutations = {
  setloading (state, s) {
    state.loading = s
  },
  setdialog (state, s) {
    state.dialog = s
  },
  settouser (state, touser) {
    state.newmessage.touser = touser
  },
  setselectedgroupid (state, groupid) {
    state.selectedgroupid = groupid
  },
  setchatlist (state, s) {
    state.chatlist = []
    state.chatlist = s.data.content
    state.totalchatlist = s.data.totalElements
    state.loading = false
    state.overlay = false
  },
  setselectedchatx (state, chat) {
    state.selectedchat = chat
  },
  addmsg (state, msg) {
    state.messages.push(msg)
  },
  setdatamessage (state, s) {
    state.messages = []

    for (let i = s.data.content.length - 1; i >= 0; i--) {
      state.messages.push(s.data.content[i])
    }

    // state.messages = s.data.content
    state.loading = false
    state.overlay = false
  }
}

export const ChatStore = {
  namespaced: true,
  state,
  actions,
  mutations
}
